import { inject, Injectable, INJECTOR, signal } from '@angular/core';
import { SOFTLINE_MDE_INVENTORY_REPOSITORY } from '../repositories/inventory.repository';
import { Inventory } from '../types/inventory';
import { handleRequestError } from '@softline/application';
import { InventoryStorage } from '../types/inventory-storage';

@Injectable()
export class InventoryService {
  private readonly repository = inject(SOFTLINE_MDE_INVENTORY_REPOSITORY);
  readonly #injector = inject(INJECTOR);

  readonly #value = signal<Inventory | null>(null);
  readonly #loaded = signal<boolean>(false);

  readonly value = this.#value.asReadonly();
  readonly loaded = this.#loaded.asReadonly();

  async loadExisting(): Promise<Inventory | null> {
    const result = await this.repository.loadExisting();
    this.set(result);
    return result;
  }

  async loadDefaultLager(): Promise<InventoryStorage | null> {
    return this.repository.loadDefaultLager();
  }

  set(value: Partial<Inventory> | null): void {
    this.#value.set(value as Inventory);
    this.#loaded.set(true);
  }

  async cancel(): Promise<boolean> {
    try {
      await this.repository.cancel();
      this.#loaded.set(false);
      return true;
    } catch (e) {
      handleRequestError(e, this.#injector, { show: true });
      return false;
    }
  }

  async finish(params: {
    schwundlisteDrucken: boolean;
    differenz: number;
  }): Promise<void> {
    await this.repository.finish(params);
  }

  reset() {
    this.#value.set(null);
    this.#loaded.set(false);
  }
}
